<template>
  <step-section
    :title="$t('thisConfigurationName')"
    :loading="loading$"
    :step-number="getStepNumber('configurationName')"
  >
    <div class="row row--custom">
      <div class="col-12">
        <div class="step-block step-block--config">
          <div class="form-group">
            <label>
              {{ $t('configurationName') }}
              <sup></sup>
            </label>
            <input
              type="text"
              class="form-control"
              :value="form.name"
              :placeholder="$t('configurationNamePlaceholder')"
              @input="handleNameChange"
            >
          </div>
        </div>
      </div>
    </div>
  </step-section>
</template>

<script>
  import stepMixin from './stepMixin';

  export default {
    name: 'ConfigurationNameStep',
    mixins: [stepMixin],
    methods: {
      handleNameChange(ev) {
        this.updateFormField({
          field: 'name',
          value: ev.target.value,
        });
      },
    },
  };
</script>
